/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createAssignProductFamilyVariantsResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeAssignProductFamilyVariantsRequest, serializeAssignProductFamilyVariantsResponse, type AssignProductFamilyVariantsRequest, type AssignProductFamilyVariantsResponse, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/product-families/{familyKey}/variants
 */
export interface VariantsRequestBuilder extends BaseRequestBuilder<VariantsRequestBuilder> {
    /**
     * Makes existing products variants of the family, recording each one's option values and merging those values into the family's axes. A product already in another family moves. SKUs with no product are reported back in missingSkus rather than created — create them first with the product endpoints, which accept the family on the row directly.
     * @param body Makes existing products variants of a family.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<AssignProductFamilyVariantsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: AssignProductFamilyVariantsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<AssignProductFamilyVariantsResponse | undefined>;
    /**
     * Makes existing products variants of the family, recording each one's option values and merging those values into the family's axes. A product already in another family moves. SKUs with no product are reported back in missingSkus rather than created — create them first with the product endpoints, which accept the family on the row directly.
     * @param body Makes existing products variants of a family.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: AssignProductFamilyVariantsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const VariantsRequestBuilderUriTemplate = "{+baseurl}/api/product-families/{familyKey}/variants";
/**
 * Metadata for all the requests in the request builder.
 */
export const VariantsRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: VariantsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createAssignProductFamilyVariantsResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAssignProductFamilyVariantsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
